import { OptionsFilter } from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class FiltersService {
	constructor() {}

	createUrl(options: OptionsFilter[]): string {
		let url = '?';
		options.forEach((item) => {
			url = `${url}_${item.name}=${item.selected}&`;
		});
		url = url.substr(0, url.length - 1);
		return url;
	}
}
